import * as React from 'react';
import useI18n from 'src/hooks/useI18n';

import Loading from 'src/components/lib/loading/loading';

import css from './image-input.css';

import {backgroundImage} from 'src/utils/index';


type Props = {
  src: string | null | undefined;
  loading?: boolean | null | undefined;
  onDelete: () => unknown;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => unknown;
  uploadHint?: React.ReactNode;
};

const ImageInput = ({
  src,
  loading,
  onDelete,
  onChange,
  uploadHint = '+ Upload File',
}: Props):
  | React.ReactElement<React.ComponentProps<'div'>>
  | React.ReactElement<React.ComponentProps<'label'>> => {
  const {labelI18nInstance} = useI18n();
  const t = labelI18nInstance.t;
  return src ? (
    <div className={css.logoContainer}>
      {/* @ts-expect-error - TS2322 - Type '{ backgroundImage: string; } | null | undefined' is not assignable to type 'CSSProperties | undefined'. */}
      <div className={css.logoPreview} style={backgroundImage(src)}></div>
      <button className={css.logoDelete} type="button" onClick={onDelete}>
        {t('Delete', 'Delete')}
      </button>
    </div>
  ) : (
    <label>
      <div className={css.logoPreviewBlank}>
        {loading ? <Loading /> : <div>{uploadHint}</div>}
      </div>
      <input className={css.logoUploadInput} type="file" onChange={onChange} />
    </label>
  );
};

export default ImageInput;
